import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://elovquwpbwdayzzywaar.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVsb3ZxdXdwYndkYXl6enl3YWFyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU5MzA4OTYsImV4cCI6MjA4MTUwNjg5Nn0.mulP036b565JIV4DNKV7BuEbGZ3BFj7CNXIq-Dmoi80';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';
